import { useQuery } from '@tanstack/react-query'
import { OpalApiResponseDocument } from '../../../schema'
import { content } from '../../../v3/content'
import { globalQueryKeys } from '../../queryKeys'

type ReadContentResponse = OpalApiResponseDocument<'ReadContentV3', 200>

/**
 * One content resource from the v3 API.
 *
 * The endpoint takes no sparse fieldset, so this reads the whole resource. Ask
 * for what you need with `select`.
 */
export const useReadContent = <T = ReadContentResponse>({
  contentId = '',
  select,
}: {
  /** The content UUID. Leave it out to hold the fetch back. */
  contentId?: string
  select?: (data: ReadContentResponse) => T
}) =>
  useQuery({
    enabled: Boolean(contentId),
    queryKey: globalQueryKeys.contentByIdV3(contentId),
    queryFn: () =>
      content.readSingle({ path: { content_id: contentId }, query: {} }),
    select,
  })
